var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"type":"pie","options":_vm.chartOptions,"series":this.series,"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }